module.exports = __webpack_public_path__ + "static/media/screen-splash.0e577c9d.png";